import {
  defaultLendAndReturnConditionUserLimit,
  exists,
  LendAndReturnConditionLendClassification,
  LendAndReturnConditionLendClassificationFromJSON,
  LendAndReturnConditionLendDay,
  LendAndReturnConditionLendDayFromJSON,
  LendAndReturnConditionUserLimit,
  LendAndReturnConditionUserLimitFromJSON
} from '@/api'

export interface LendAndReturnCondition {
  lendDays: LendAndReturnConditionLendDay[]
  userLimits: LendAndReturnConditionUserLimit
  lendClassifications: LendAndReturnConditionLendClassification[]
}

export const defaultLendAndReturnCondition = (): LendAndReturnCondition => ({
  lendDays: [],
  userLimits: defaultLendAndReturnConditionUserLimit(),
  lendClassifications: []
})

export function LendAndReturnConditionFromJSON(
  json: any
): LendAndReturnCondition {
  return {
    lendDays: exists(json, 'lend_days')
      ? json.lend_days.map(LendAndReturnConditionLendDayFromJSON)
      : [],
    userLimits: exists(json, 'user_limits')
      ? LendAndReturnConditionUserLimitFromJSON(json.user_limits)
      : defaultLendAndReturnConditionUserLimit(),
    lendClassifications: exists(json, 'lend_classifications')
      ? json.lend_classifications.map(
          LendAndReturnConditionLendClassificationFromJSON
        )
      : []
  }
}
